// JS
import React from 'react';
import { randomId } from '../shared/utils';
import { Skeleton } from '../Ui/skeleton';

// COMPONENT
const CreativeFeature = ({
  creativeFeatureOptions,
  data,
  gaBlockName,
  showCreativeFeature = true,
  lazyLoad = true
}) => {
  const uniqueId = randomId();

  return (
    <section
      id={'creative-feature-' + uniqueId}
      className={
        showCreativeFeature
          ? 'container my-24 lg:my-48 w-100' +
            (creativeFeatureOptions?.classes
              ? ' ' + creativeFeatureOptions.classes
              : '')
          : 'hidden'
      }
    >
      {data ? (
        <div
          className="flex flex-col gap-x-6 md:pt-5 md:flex-row"
          data-name={data[0].block_title + ' & ' + data[1].block_title}
          data-creative={gaBlockName}
          data-id={data[0].contentguid + '-&-' + data[1].contentguid}
          data-position={'banner-slot-1'}
          data-type="banner"
        >
          {data.map((feature, index) => (
            <a
              key={'creative-feature-' + index}
              href={feature.url}
              target={
                feature.url && feature.url.includes('www.sevenstore.com')
                  ? '_self'
                  : '_blank'
              }
              rel="noreferrer"
              className={`w-full flex flex-col justify-between md:w-6/12 ${
                index === 0 ? 'mb-12 md:mb-0' : ''
              }`}
              data-name={feature.block_title + ' ' + feature.block_sub_title}
              data-creative={gaBlockName}
              data-id={feature.contentguid}
              data-position={'button-slot-' + (index + 1)}
              data-type="banner-button"
            >
              <div className="flex items-end w-full aspect-[9/7] bg-cover bg-center bg-no-repeat mb-5 md:mb-10">
                <img
                  src={feature.icon}
                  alt=""
                  loading={lazyLoad ? 'lazy' : 'eager'}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="text-lg md:text-xl text-left uppercase">
                <h2 className="font-bold">{feature.block_title}</h2>
                <p className="font-base text-md md:text-lg">
                  {feature.block_sub_title}
                </p>
              </div>
            </a>
          ))}
        </div>
      ) : (
        <div className="grid gap-5 md:grid-cols-2 w-full ">
          <div className="grid gap-2 w-full h-[400px] md:h-[350px] xl:h-[550px] 2xl:h-[650px]">
            <Skeleton className="aspect-square h-[340px] md:h-[370px] xl:h-[470px] 2xl:h-[570px]" />
            <div>
              <Skeleton className="aspect-square h-[20px] w-[250px] mb-2" />
              <Skeleton className="aspect-square h-[20px] w-[120px]" />
            </div>
          </div>
          <div className="grid gap-2 w-full h-[400px] md:h-[350px] xl:h-[550px] 2xl:h-[650px]">
            <Skeleton className="aspect-square h-[340px] md:h-[370px] xl:h-[470px] 2xl:h-[570px]" />
            <div>
              <Skeleton className="aspect-square h-[20px] w-[250px] mb-2" />
              <Skeleton className="aspect-square h-[20px] w-[120px]" />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default CreativeFeature;
